import React, { useEffect } from 'react'
// import { withTheme } from 'styled-components/macro'
import styled from '@emotion/styled'

import {
  Grid,
  Hidden,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Typography
} from '@mui/material'

import {
  Business,
  Menu as MenuIcon,
  Person,
  Store,
  Storefront
} from '@mui/icons-material'

import UserDropdown from './UserDropdown'
import { useFetchBusinessById } from '../modules/business/businessHooks'
import { useFetchUserById } from '../modules/user/userHooks'
import {
  getBusinessDetails,
  getLoggedInUser,
  getOutletName,
  getSubBusinessName,
  getUserNameFromToken,
  getUserType
} from './tsComponents/AuthGuard'

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`

const StyledIcon = styled('div')`
  display: flex;
  align-items: center;
  padding-bottom: 2px;

  svg {
    width: 20px;
    height: 20px;
  }
`

function AppBarComponent({ onDrawerToggle }) {
  const businessData = getBusinessDetails()
  const loggedInUserType = getLoggedInUser()
  const userType = getUserType()
  const subBusinessName = userType === 'FOwner' ? getSubBusinessName() : ''
  const loggedInUserName = getUserNameFromToken()
  const { fetchBusinessByApplicationData } = useFetchBusinessById()
  const { userFetchById, userFetchByIdData } = useFetchUserById()

  useEffect(() => {
    // Fetch user data when component mounts to get latest user information
    userFetchById()
  }, [])

  // Get the display name - prioritize first_name from user data, fallback to username from token
  const displayName =
    userFetchByIdData?.first_name || loggedInUserName || 'User'

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{ boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)' }}
      >
        <Toolbar sx={{ minHeight: '64px', paddingY: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Grid container alignItems="center" justifyContent="space-between">
            <Hidden mdUp>
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                  size="large"
                >
                  <MenuIcon />
                </IconButton>
              </Grid>
            </Hidden>
            <Grid item>
              <Grid container alignItems="center">
                {(businessData || fetchBusinessByApplicationData) && (
                  <>
                    <Grid item pr={3}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Business sx={{ fontSize: '24px', display: 'flex', paddingBottom: '6px' }} />
                        <Typography
                          variant="h6"
                          component="h1"
                          color="inherit"
                          noWrap
                          sx={{ margin: 0, lineHeight: '24px', display: 'flex', alignItems: 'center' }}
                        >
                          {businessData?.name ??
                            fetchBusinessByApplicationData?.name}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item pr={3} display="flex" alignItems="center">
                      |
                    </Grid>
                  </>
                )}
                {userType === 'FOwner' && subBusinessName && (
                  <>
                    <Grid item pr={3}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Store sx={{ fontSize: '24px', display: 'flex', paddingBottom: '6px' }} />
                        <Typography
                          variant="h6"
                          component="h1"
                          color="inherit"
                          noWrap
                          sx={{ margin: 0, lineHeight: '24px', display: 'flex', alignItems: 'center' }}
                        >
                          {subBusinessName}
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item pr={3} display="flex" alignItems="center">
                      |
                    </Grid>
                  </>
                )}
                <Grid item>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Person sx={{ fontSize: '24px', display: 'flex', paddingBottom: '6px' }} />
                    <Typography
                      variant="h6"
                      component="h1"
                      color="inherit"
                      noWrap
                      sx={{ margin: 0, lineHeight: '24px', display: 'flex', alignItems: 'center' }}
                    >
                      {loggedInUserType ?? 'User'}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs />
            <Grid item display="flex" alignItems="center">
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Person sx={{ fontSize: '24px', display: 'flex', paddingBottom: '6px' }} />
                    <Typography
                      variant="h6"
                      component="h1"
                      color="inherit"
                      noWrap
                      sx={{ margin: 0, lineHeight: '24px', display: 'flex', alignItems: 'center' }}
                    >
                      {displayName}
                    </Typography>
                  </div>
                </Grid>
                <Grid item display="flex" alignItems="center" pl={2}>
                  |
                </Grid>
                <Grid item display="flex" alignItems="center">
                  {/* <MessagesDropdown />
                  <NotificationsDropdown />
                  <LanguagesDropdown /> */}
                  <UserDropdown />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </>
  )
}

// export default withTheme(AppBarComponent)
export default AppBarComponent
